<app-pageheader [Parent]="this">
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="enforcement/appeals/searches"
  [AllowEdit]="true" EditUrl="enforcement/citations/appeals/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-infringement-types-filter></div>
    <div app-subset-filter [Subsets]="getStatuses()" Subset="Open"></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>

